import { render, staticRenderFns } from "./ClassesEdit.vue?vue&type=template&id=d30bf56a&scoped=true"
import script from "./ClassesEdit.vue?vue&type=script&lang=js"
export * from "./ClassesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30bf56a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d30bf56a')) {
      api.createRecord('d30bf56a', component.options)
    } else {
      api.reload('d30bf56a', component.options)
    }
    module.hot.accept("./ClassesEdit.vue?vue&type=template&id=d30bf56a&scoped=true", function () {
      api.rerender('d30bf56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolManage/classes/ClassesEdit.vue"
export default component.exports